var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ChipSelectorShell',_vm._g(_vm._b({attrs:{"type":"checkbox","default-required-message":"Please select at least one option"}},'ChipSelectorShell',[_vm.$attrs, _vm.questionBinder],false),_vm.questionEventBinder))}
var staticRenderFns = []

export { render, staticRenderFns }